const AbstractResourcesView = require("../common/AbstractResourcesView");
const Utils = require("common/Utils");

/**
 * Display a list of Apps
 *
 * @class
 * @extends {AbstractResourcesView}
 * @param launcher {Callback}
 */
function AppsListView(launcher) {
    AbstractResourcesView.call(this, launcher);

    var contentClass = "apps";
    this.getContent().attr("data-nav-icon-class", contentClass);

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "AppsList";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getWeight = function() {
        return 5;
    };

    var super_headerConf = this.getHeaderConfiguration;
    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return $.extend(super_headerConf(), {
            title : $.t("common::resources.filter.apps"),
            i18n : "common::resources.filter.apps",
            contentClass : contentClass
        });
    };
}
Utils.inherits(AppsListView, AbstractResourcesView);

module.exports = AppsListView;